const carouselItems = [
  {
    title: '韩漫腐 · 2026夏季热门推荐',
    desc: '今年夏天最值得追的韩漫腐作品都在这里了！从甜蜜校园到职场虐恋，编辑部为你精选 30 部不可错过的韩漫腐佳作，每一部都值得通宵追完。',
    img: 'https://readdy.ai/api/search-image?query=Korean%20webtoon%20illustration%20of%20two%20stylish%20young%20men%20in%20summer%20clothing%2C%20one%20wearing%20a%20light%20shirt%2C%20the%20other%20in%20casual%20attire%2C%20standing%20on%20a%20sunny%20beach%20with%20soft%20waves%2C%20warm%20golden%20sunset%20light%2C%20romantic%20summer%20vibe&width=900&height=500&seq=carousel-item-01&orientation=landscape',
    tag: '夏季专题',
  },
  {
    title: '日漫腐 · 经典入门必读指南',
    desc: '如果你是日漫腐的新读者，这份入门指南请收好！从《樱花树下的约定》到更多口碑经典，帮你快速找到适合自己口味的第一部日漫腐。',
    img: 'https://readdy.ai/api/search-image?query=Japanese%20manga%20style%20illustration%20of%20two%20handsome%20high%20school%20boys%20sitting%20together%20on%20a%20rooftop%2C%20watching%20sunset%2C%20school%20bags%20beside%20them%2C%20cherry%20blossom%20petals%20in%20the%20air%2C%20nostalgic%20and%20warm%20atmosphere&width=900&height=500&seq=carousel-item-02&orientation=landscape',
    tag: '入门指南',
  },
  {
    title: '国漫耽美 · 原创力量巡礼',
    desc: '国漫耽美正在崛起！我们精选了一批画风精美、剧情扎实的本土原创作品，涵盖古风、现代、奇幻等多种题材，见证中国耽美漫画的成长与突破。',
    img: 'https://readdy.ai/api/search-image?query=Chinese%20ancient%20style%20illustration%20of%20two%20elegant%20male%20characters%20in%20flowing%20traditional%20hanfu%2C%20standing%20in%20a%20bamboo%20forest%20with%20soft%20mist%2C%20ink%20wash%20painting%20aesthetic%2C%20ethereal%20and%20refined&width=900&height=500&seq=carousel-item-03&orientation=landscape',
    tag: '原创力量',
  },
  {
    title: '校园纯爱 · 高甜合集推荐',
    desc: '校园是纯爱故事最经典的舞台！从青涩告白到毕业约定，我们整理了评分最高的校园纯爱腐漫合集，每一部都能让你嘴角上扬、心跳加速。',
    img: 'https://readdy.ai/api/search-image?query=Two%20handsome%20male%20students%20in%20school%20uniforms%20walking%20together%20through%20a%20tree-lined%20campus%20path%2C%20sunlight%20filtering%20through%20leaves%2C%20one%20laughing%2C%20the%20other%20blushing%2C%20soft%20watercolor%20style%2C%20warm%20spring%20atmosphere&width=900&height=500&seq=carousel-item-04&orientation=landscape',
    tag: '高甜合集',
  },
  {
    title: '奇幻异世界 · 魔法与爱情',
    desc: '当BL遇见奇幻，会碰撞出怎样的火花？魔法学院、异世界穿越、龙与骑士——这些题材下的腐漫故事，有着最宏大的世界观和最动人的感情线。',
    img: 'https://readdy.ai/api/search-image?query=Fantasy%20manga%20illustration%20of%20a%20dark-haired%20mage%20and%20a%20silver-haired%20knight%20standing%20before%20a%20glowing%20magical%20portal%2C%20floating%20crystals%20and%20spell%20runes%2C%20dramatic%20lighting%2C%20epic%20fantasy%20atmosphere&width=900&height=500&seq=carousel-item-05&orientation=landscape',
    tag: '奇幻专题',
  },
  {
    title: '完结全集 · 一次追到爽',
    desc: '追连载太痛苦？不如来看看这些已完结的优质腐漫全集！从短篇到长篇，从韩漫腐到国漫耽美，一次性读完完整故事的满足感绝对让你停不下来。',
    img: 'https://readdy.ai/api/search-image?query=Cozy%20reading%20scene%20with%20a%20stack%20of%20colorful%20manga%20books%20on%20a%20wooden%20desk%2C%20warm%20lamp%20light%2C%20a%20cup%20of%20tea%2C%20soft%20blanket%20in%20background%2C%20comfortable%20home%20library%20atmosphere%2C%20golden%20evening%20light%20from%20window&width=900&height=500&seq=carousel-item-06&orientation=landscape',
    tag: '完结全集',
  },
];

export default function CarouselSection() {
  return (
    <section id="carousel" className="py-12 md:py-16 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-7xl mx-auto">
        <div className="text-center mb-8 md:mb-10">
          <h2 className="font-heading text-xl md:text-2xl font-bold text-foreground-950">
            焦点专题
          </h2>
          <p className="mt-2 text-sm text-foreground-500">编辑部精心策划的腐漫专题内容</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {carouselItems.map((item) => (
            <a
              key={item.title}
              href="#cards"
              className="group block rounded-xl overflow-hidden bg-background-100 border border-background-200/70 hover:border-primary-300 transition-all cursor-pointer"
            >
              <div className="relative aspect-[16/10] overflow-hidden">
                <img
                  src={item.img}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/35 to-transparent"></div>
                <span className="absolute top-3 left-3 px-2.5 py-1 rounded-md bg-accent-500 text-background-50 text-[10px] font-semibold whitespace-nowrap">
                  {item.tag}
                </span>
              </div>
              <div className="p-4 md:p-5">
                <h3 className="text-sm md:text-base font-semibold text-foreground-900 group-hover:text-primary-600 transition-colors line-clamp-2">
                  {item.title}
                </h3>
                <p className="mt-2 text-xs md:text-sm text-foreground-500 leading-relaxed line-clamp-3">
                  {item.desc}
                </p>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}